import Vue from 'vue'
import App from '@/App.vue'

import BradfordWhite from '@/plugins/bradfordwhite'

import router from '@/router'
import store from '@/store'

import VueCookies from 'vue-cookies'

Vue.use(VueCookies);
Vue.use(BradfordWhite);
Vue.config.productionTip = false;

// set default cookie expiry config to 1d
VueCookies.config('1d')

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
